import { render } from "./VabeneAddIngredient.vue?vue&type=template&id=c87d35ac&ts=true"
import script from "./VabeneAddIngredient.vue?vue&type=script&lang=ts"
export * from "./VabeneAddIngredient.vue?vue&type=script&lang=ts"

import "./VabeneAddIngredient.vue?vue&type=style&index=0&id=c87d35ac&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__